/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_C11Inputs */

const en_cv_extract_form_enum_c11 = /** @type {(inputs: Cv_Extract_Form_Enum_C11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C1 - Advanced`)
};

const de_cv_extract_form_enum_c11 = /** @type {(inputs: Cv_Extract_Form_Enum_C11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C1 - Fachkundige Sprachkenntnisse`)
};

/**
* | output |
* | --- |
* | "C1 - Advanced" |
*
* @param {Cv_Extract_Form_Enum_C11Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_c11 = /** @type {((inputs?: Cv_Extract_Form_Enum_C11Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_C11Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_c11(inputs)
	return en_cv_extract_form_enum_c11(inputs)
});
export { cv_extract_form_enum_c11 as "cv_extract_form_enum_C1" }